module.exports = __webpack_public_path__ + "img/badge-list-thumb-024.71b21b0a.png";